import { createFileRoute } from '@tanstack/react-router';

import { readCheckBreadcrumbNames } from '../../features/quality-packs/breadcrumb-data';
import { CheckDetailPage } from '../../features/quality-packs/check-detail-page';

export const Route = createFileRoute('/quality-packs/$workOrderId_/$jobCardId/$orderNumber')({
  staticData: {
    // This route is un-nested from the pack (the `$workOrderId_` opt-out), so
    // it emits both crumbs itself: "Quality Packs > {work order} > {check}".
    // The work-order crumb links back to the pack; both names come from the
    // cached check-detail response, so the trail fills in once it loads.
    breadcrumb: (match, queryClient) => {
      const { workOrderId, jobCardId, orderNumber } = match.params as {
        workOrderId: string;
        jobCardId: string;
        orderNumber: string;
      };
      const names = readCheckBreadcrumbNames(queryClient, jobCardId, orderNumber);
      if (!names) return null;
      return [
        { label: names.workOrderName, path: `/quality-packs/${workOrderId}` },
        { label: names.checkName, path: match.pathname },
      ];
    },
  },
  component: CheckDetailRoute,
});

function CheckDetailRoute() {
  const { workOrderId, jobCardId, orderNumber } = Route.useParams();
  return (
    <CheckDetailPage workOrderId={workOrderId} jobCardId={jobCardId} orderNumber={orderNumber} />
  );
}
